import { render, staticRenderFns } from "./ChooseAgreementYear.vue?vue&type=template&id=64037040&scoped=true&lang=pug&"
import script from "./ChooseAgreementYear.vue?vue&type=script&lang=js&"
export * from "./ChooseAgreementYear.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAgreementYear.vue?vue&type=style&index=0&id=64037040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64037040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
